import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import CheckmarkIcon from '../assets/icons/JSX/CheckmarkIcon'
import EarthLogo from '../assets/icons/JSX/EarthLogo'
import SmallArrow from '../assets/icons/JSX/SmallArrow'
import Colors from '../assets/styles/Colors'
import { EnabledLanguage, supportedLocales } from '../domain/types'
import { useAppDispatch, useAppSelector } from '../store'
import { AppState, setLoading, setLanguage } from '../store/appSlice'
import { useTranslation } from 'react-i18next'
import Loader from './Loader'
import { DayjsLocalManager } from '../screens/hooks/DayjsLocalManager'

const LangDropdown = () => {
  //
  const { lang, isLoading } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const dispatch = useAppDispatch()
  //

  const [openDropdown, setOpenDropdown] = useState<boolean>(false)
  const btnRef = useRef(null)

  useEffect(() => {
    const closeDropdown = (e: any) => {
      const path = e.path || (e.composedPath && e.composedPath())
      if (path[0] !== btnRef.current) {
        setOpenDropdown(false)
      }
    }
    document.body.addEventListener('click', closeDropdown)
    return () => document.body.removeEventListener('click', closeDropdown)
  }, [])
  //
  //
  const { i18n } = useTranslation()
  //
  const changeLanguage = (lng: EnabledLanguage) => {
    // set dayjs language
    DayjsLocalManager(lng === 'ge' ? 'ka' : lng)
    // show loader
    dispatch(setLoading(true))
    // change language
    i18n.changeLanguage(lng)
    // set language in redux store
    dispatch(setLanguage(lng))
    // hide loader
    setTimeout(() => {
      dispatch(setLoading(false))
    }, 800)
  }
  //
  //
  return isLoading ? (
    <Loader />
  ) : (
    <Wrapper className="language-dropdown-wrapper">
      <LangBtn ref={btnRef} onClick={() => setOpenDropdown(!openDropdown)}>
        <EarthLogoStyle />
        <LangText>{lang === 'ge' ? 'ქარ' : 'Eng'}</LangText>
        <SmallArrowStyle $openDropdown={openDropdown} />
      </LangBtn>
      {openDropdown ? (
        <DropDownContent>
          <Ul>
            {supportedLocales.map((language, index) => (
              <Li value={language} key={index} onClick={() => changeLanguage(language)}>
                <span>{language === 'ge' ? 'ქარ' : 'Eng'}</span>
                {lang === language && <CheckmarkIconStyle />}
              </Li>
            ))}
          </Ul>
        </DropDownContent>
      ) : null}
    </Wrapper>
  )
}

// style
const CheckmarkIconStyle = styled(CheckmarkIcon)`
  ${Responsive.mobile} {
    display: none;
  }
`
const Ul = styled.ul`
  margin: 0;
  padding-left: 0px;
`
const Li = styled.li`
  list-style: none;
  height: 38px;
  padding-left: 14px;
  padding-right: 5px;
  border-radius: 2px;
  width: 88px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 14px;

  svg {
    margin-top: -2px;
  }

  &:hover {
    background-color: ${Colors.lightGrey};
    ${Responsive.mobile} {
      background-color: transparent;
    }
  }
  ${Responsive.mobile} {
    width: 100%;
  }
`
const DropDownContent = styled.div`
  position: absolute;
  top: 40px;
  left: 2px;
  width: 110px;
  z-index: 5;
  background-color: ${Colors.white};
  border-radius: 4px;
  padding: 13px;
  box-shadow: 0px 1px 5px -2px rgba(0, 0, 0, 0.41);
  -webkit-box-shadow: 0px 1px 5px -2px rgba(0, 0, 0, 0.41);
  -moz-box-shadow: 0px 1px 5px -2px rgba(0, 0, 0, 0.41);

  ${Responsive.mobile} {
    left: 21px;
    width: 100%;
    background-color: transparent;
    box-shadow: unset;
    position: unset;
    padding-left: 31px;
  }
`
const LangBtn = styled.button`
  width: 80px;
  padding: 0px 2px;
  margin: 0px;
  border: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  ${Responsive.mobile} {
    width: 100%;
    justify-content: flex-start;
  }
`
const EarthLogoStyle = styled(EarthLogo)`
  height: 17px;
  pointer-events: none;
  user-select: none;
`
const SmallArrowStyle = styled(SmallArrow)<{ $openDropdown: boolean }>`
  width: 10px;
  pointer-events: none;
  user-select: none;
  transform: rotate(${({ $openDropdown }) => ($openDropdown === true ? '0deg' : '180deg')});
  /* margin-top: 2px; */
  ${Responsive.mobile} {
    margin-left: auto;
  }
`
const LangText = styled.span`
  text-transform: capitalize;
  font-size: 14px;
  color: ${Colors.Black};
  pointer-events: none;
  user-select: none;
  ${Responsive.mobile} {
    margin-left: 24px;
  }
`
const Wrapper = styled.div`
  position: relative;
  ${Responsive.mobile} {
    width: 100%;
  }
`

export default LangDropdown
